<template>
  <div class="box-wrapper">
    <div class="box-info px-3 pt-3 rounded">
      <div class="box-title">SELECTED SARUS</div>
      <div class="saru-list py-3">
        <div
          class="saru-item"
          v-for="(item, inx) in saruIds"
          :key="`img-saru-${item.tokenId}`"
        >
          <b-img
            @click="onSaruSelected(inx)"
            class="img-saru"
            :src="item.thumbnail"
          />
          <div class="note">#{{ item.tokenId }}</div>
          <div class="i-close" @click="removeCheck(item.tokenId, 'saru')">
            ×
          </div>
        </div>
      </div>
      <div v-if="itemIds.length > saruInx" class="box-title">
        SELECTED ITEMS
      </div>
      <div class="item-list d-flex" v-if="itemIds.length > saruInx">
        <div
          class="kuni-item"
          v-for="it in filterItemIds"
          :key="`${saruInx}-${it}`"
        >
          <span @click="removeCheck(it, utils.toItemTypeBy(it, true))">
            <b-icon-x variant="danger" class="mr-1" /> </span
          >#{{ it }}
        </div>
      </div>
      <div class="tb-info" v-if="nioh">
        <div class="tb-row">
          <div class="title saru font-weight-bold">SARU</div>
          <!-- <div class="bp">{{ utils.bigToCommon(power, 18, 0) }}</div> -->
          <div class="score">{{ utils.bigToCommon(score, 18, 0) }}</div>
        </div>
        <div class="tb-row">
          <div class="title font-weight-bold">VS</div>
          <!-- <div class="bp">BP</div> -->
          <div class="score">Score</div>
        </div>
        <div class="tb-row">
          <div class="title nioh font-weight-bold">NIOH</div>
          <!-- <div class="bp">{{ utils.bigToCommon(nioh.total, 18, 0) }}</div> -->
          <div class="score">{{ utils.bigToCommon(nioh.score, 18, 0) }}</div>
        </div>
      </div>
      <div
        class="box-action d-flex my-3 justify-content-between align-items-center"
      >
        <div>
          <span class="mr-2 share-link" @click="onLink">Share Link</span>
          <b-icon-file-earmark-check variant="info" v-if="copied" />
          <b-icon-files class="w-copied" v-else @click="onCopied" />
        </div>
        <div>
          <b-btn class="px-3 btn-action" @click="$emit('onClose')"
            >Cancel</b-btn
          >
          <b-btn class="ml-3 px-3 btn-action btn-update" @click="onUpdate"
            >Update</b-btn
          >
        </div>
      </div>
    </div>
    <div class="box-filter mt-3">
      <div class="o-filter mb-3">
        <div class="w-100">
          <b-form-group
            id="sg-1"
            class="w-100 mb-0"
            label="Filter By"
            label-for="fs-01"
          >
            <b-form-select
              class="ip-select mb-0"
              v-model="saruSelected"
              id="fs-01"
              :options="optionsBy"
              @change="onChangeType"
              plain
            />
          </b-form-group>
        </div>
        <div class="d-flex w-100 group-sort">
          <b-form-group
            id="sg-2"
            size="sm"
            label="Sort By"
            label-for="fs-02"
            class="w-100 mb-0"
          >
            <b-form-select
              class="ip-select"
              v-model="sortBy"
              id="fs-02"
              plain
              @change="onChangeSort"
              :options="battlePower"
            />
          </b-form-group>
          <b-btn class="btn-sort mt-0">
            <b-icon
              class="h3 mb-0 ic-sort"
              :icon="`sort-${isAsc ? 'up' : 'down'}`"
              @click="onChangeSortType"
            />
          </b-btn>
        </div>
      </div>
      <b-input-group>
        <b-form-input
          class="text-search"
          type="search"
          v-model="textSearch"
          @change="myFetch"
          placeholder="Enter ID, Owner"
        />
      </b-input-group>
    </div>
    <div class="box-list my-3">
      <b-table
        id="token-list"
        size="sm"
        :busy.sync="isBusy"
        :items="list"
        :fields="fields"
        :perPage="perPage"
        :currentPage="currentPage"
      >
        <template #cell(tokenId)="value">
          <div class="cell-tokenid justify-content-between">
            <div class="d-flex cell-wrap">
              <b-form-checkbox
                class="m-checked"
                v-model="
                  checked[
                    isSaru
                      ? 'saru'
                      : utils.toItemTypeBy(value.item.tokenId, true)
                  ][value.item.tokenId]
                "
                @change="
                  (checked) =>
                    onChecked(
                      checked,
                      value.item.tokenId,
                      isSaru
                        ? 'saru'
                        : utils.toItemTypeBy(value.item.tokenId, true)
                    )
                "
              >
                <b-img rounded :src="value.item.thumbnail" class="thumbnail" />
                <span class="ml-2">#{{ value.item.tokenId }}</span>
              </b-form-checkbox>
            </div>
            <div class="ic-power d-fex">
              <div
                v-if="utils.getIconPower(value.item.attIcon)"
                v-b-tooltip.hover
                :title="value.item.attIcon.toUpperCase()"
              >
                <b-img-lazy
                  rounded
                  :src="utils.getIconPower(value.item.attIcon)"
                />
              </div>
              <div
                v-if="utils.getIconPower(value.item.defIcon)"
                v-b-tooltip.hover
                :title="value.item.defIcon.toUpperCase()"
              >
                <b-img-lazy
                  rounded
                  :src="utils.getIconPower(value.item.defIcon)"
                />
              </div>
            </div>
          </div>
        </template>
        <template #cell(powerTotal)="value">
          <span v-if="value.item.powerTotal">{{
            utils.bigToCommon(value.item.powerTotal, 18, 2)
          }}</span>
        </template>
        <template #cell(rate)="value">
          <span>{{ value.item.rate || "0" }}%</span>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
      <div class="table-page d-flex justify-content-end align-self-center">
        <div class="mr-2 pt-1">{{ totalRecord }}/{{ total }} Records</div>
        <b-pagination
          v-if="perPage < total"
          pills
          :limit="3"
          class="custom-pagination mb-0"
          :total-rows="total"
          v-model="currentPage"
          :per-page="perPage"
          aria-controls="token-list"
          hide-ellipsis
        />
      </div>
    </div>
    <b-toast
      id="update-success"
      toast-class="b-success"
      title="Success"
      solid
      auto-hide-delay="5000"
    >
      Your update is successful.
    </b-toast>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CoreGame, Scholarship } from "@/amakunicom/sdk";
import { ethers } from "ethers";

const KEY_SAVE_SEARCH = "search-select";
const fields = [
  { key: "tokenId", label: "ID" },
  { key: "powerTotal", label: "Total", class: "text-right" },
];

export default {
  name: "SelectTeam",
  computed: {
    ...mapGetters("saru", ["toTokenIds", "toItemIds"]),
    total() {
      return this.list.length;
    },
    isSaru() {
      return this.saruSelected.endsWith("Saru");
    },
    nameChecked() {
      return this.isSaru ? "saru" : "item";
    },
    totalRecord() {
      return this.currentPage * this.perPage >= this.total
        ? this.total
        : this.currentPage * this.perPage;
    },
    fields() {
      if (this.saruSelected.startsWith("rent"))
        return [
          ...fields,
          { key: "rate", label: "Rate", class: "text-right", sortable: false },
        ];
      return fields;
    },
    filterItemIds() {
      return (this.itemIds[this.saruInx] || []).filter((t) => t > 0);
    },
  },
  data: () => ({
    textSearch: "",
    isAsc: false,
    perPage: 6,
    currentPage: 1,
    isBusy: false,
    saruSelected: "rentSaru",
    sortBy: "powerTotal",
    optionsBy: [
      { value: "rentSaru", text: "SARU For Rent" },
      { value: "rentItem", text: "ITEM For Rent" },
      { value: "mySaru", text: "Your SARU" },
      { value: "myItem", text: "Your ITEM" },
      { value: "sugSaru", text: "Suggested SARU" },
      { value: "sugItem", text: "Suggested ITEM" },
    ],
    battlePower: [
      { value: "powerTotal", text: "POWER TOTAL" },
      { value: "defendTotal", text: "POWER DEFEND" },
      { value: "attackTotal", text: "POWER ATTACK" },
    ],
    saruIds: [],
    itemIds: [],
    list: [],
    checked: {},
    copied: false,
    power: ethers.constants.Zero,
    score: ethers.constants.Zero,
    itemSelect: {},
    nioh: null,
    saruInx: 0,
  }),
  async created() {
    let searchSave = sessionStorage.getItem(KEY_SAVE_SEARCH);
    if (searchSave) {
      searchSave = JSON.parse(searchSave);
      this.textSearch = searchSave.textSearch || "";
      this.saruSelected = searchSave.saruSelected || "rentSaru";
    }
    this.$store.dispatch("saru/updateMeta", {
      meta: this.mStore.getItemMeta(),
    });
    this.checked = this.utils.toDefautCheckList();
    this.saruIds = this.toTokenIds;
    this.itemIds = this.toItemIds;
    this.signer = await this.provider.getSigner();
    this.account = await this.signer.getAddress();
    this.tokens = this.getCoreConfig();
    this.game = new CoreGame(this.tokens, this.provider);
    this.scholar = await Scholarship.initWith(
      this.tokens.scholarship,
      this.provider
    );
    const self = this;
    this.updateItemInit();
    this.shuffled();
    this.saruIds.forEach(({ tokenId }) => {
      self.checked["saru"][`${tokenId}`] = true;
    });
    for (const key in this.itemSelect) {
      if (!self.checked[key]) self.checked[key] = {};
      for (let j = 0; j < this.itemSelect[key].length; j++) {
        const tId = Number(this.itemSelect[key][j]);
        self.checked[key][tId] = true;
      }
    }
    this.calScore();
    this.myFetch();
  },
  methods: {
    ...mapActions("saru", [
      "getTokenIds",
      "getById",
      "updateMeta",
      "getMetaUpdateByTokenId",
      "getMetaByTokenId",
    ]),
    onSaruSelected(inx) {
      this.saruInx = inx;
    },
    onChangeType() {
      this.currentPage = 1;
      this.myFetch();
    },
    async myFetch() {
      this.isBusy = true;
      let result;
      let nftAddr = this.tokens.kuniItem;
      if (this.saruSelected.endsWith("Saru")) {
        nftAddr = this.tokens.kuniSaru;
      }
      if (this.saruSelected.startsWith("rent")) {
        let acc = this.tokens.scholarship;
        if (ethers.utils.isAddress(this.textSearch)) {
          acc = this.textSearch;
        }
        result = await this.scholar.nftBy(nftAddr, acc, this.isSaru, false);
      } else if (this.saruSelected.startsWith("sug")) {
        result = await this.getSuggest(nftAddr, this.isSaru);
      } else if (this.saruSelected.startsWith("my")) {
        let acc = this.account;
        if (ethers.utils.isAddress(this.textSearch)) {
          acc = this.textSearch;
        }
        result = await this.game.fetchNFTBy(nftAddr, acc, this.isSaru, false);
      }

      if (!this.isSaru) {
        const items = await this.updateFetchMeta(result.data);
        result.data = items.data;
      }
      this.list = await this.$store.dispatch("saru/getTokenIds", {
        tokenIds: result.data,
        sortBy: this.sortBy,
        sortType: this.isAsc,
        isSaru: this.isSaru,
      });
      this.onSearchText();
      this.isBusy = false;
    },
    async onChangeSort() {
      this.list = await this.$store.dispatch("saru/getTokenIdAndSort", {
        tokenIds: this.list,
        sortBy: this.sortBy,
        sortType: this.isAsc,
      });
    },
    onChangeSortType() {
      this.isAsc = !this.isAsc;
      this.onChangeSort();
    },
    onSearchText() {
      sessionStorage.setItem(
        KEY_SAVE_SEARCH,
        JSON.stringify({
          textSearch: this.textSearch || "",
          saruSelected: this.saruSelected || "rentSaru",
        })
      );
      if (this.textSearch && !ethers.utils.isAddress(this.textSearch)) {
        this.list = this.list.filter(({ tokenId }) =>
          this.$_.includes(`${tokenId}`, this.textSearch)
        );
      }
    },
    async onChecked(checked, tokenId, key) {
      tokenId = Number(tokenId);
      if (key === "saru") {
        this.saruIds = this.saruIds.filter(
          (item) => Number(item.tokenId) !== tokenId
        );
        if (checked) {
          const item = await this.$store.dispatch("saru/getById", tokenId);
          item.tokenId = item.id;
          this.saruIds.push(item);
        }
      } else {
        if (!this.itemSelect[key]) {
          this.itemSelect[key] = [];
        }
        this.itemSelect[key] = this.itemSelect[key].filter(
          (it) => Number(it) !== tokenId
        );
        if (checked) {
          this.itemSelect[key].push(tokenId);
        }
      }
      this.shuffled();
      this.calScore();
    },
    async removeCheck(tokenId, key) {
      this.checked[key][Number(tokenId)] = false;
      await this.onChecked(false, tokenId, key);
    },
    shuffled() {
      let len = this.saruIds.length;
      let start = 0;
      if (len > 6) {
        start = len - 6;
      }
      this.saruIds = this.saruIds.slice(start, len);
      this.itemIds = this.getItems();
    },
    async onCopied() {
      this.copied = true;
      const ids = this.onEncode();
      const code = this.mStore.getMyRef();
      await this.$clipboard(
        `${window.location.origin}?ids=${ids}&code=${code}`
      );
      await new Promise((r) => setTimeout(r, 1000));
      this.copied = false;
    },
    async calScore() {
      const { saru, score, nioh } = await this.game.getPowerFight(
        this.saruIds.map(({ tokenId }) => tokenId),
        this.account,
        this.itemIds
      );
      this.power = saru.total;
      this.score = score.saru;
      this.nioh = { total: nioh.total, score: score.nioh };
    },
    onEncode() {
      const items = this.itemIds.map((vals) =>
        vals.map((t) => Number(t)).join("_")
      );
      return btoa(
        this.saruIds
          .map(({ tokenId }, inx) => {
            let str = Number(tokenId);
            if (inx < items.length) {
              str += `+${items[inx]}`;
            }
            return str;
          })
          .join("-")
      );
    },
    onUpdate() {
      //   const code = this.onEncode();
      //   this.mSession.setFighting(code);
      this.$store.dispatch("saru/updateTeam", {
        tokenIds: this.saruIds.map(({ tokenId }) => tokenId),
        itemIds: this.itemIds,
      });
      this.$bvModal.hide("select-team-modal");
      this.$eventBus.$emit("saru-load-data");
      this.$bvToast.show("update-success");
    },
    onLink() {
      const ids = this.onEncode();
      const code = this.mStore.getMyRef();
      const { href } = this.$router.resolve({
        name: "QuickEarn",
        query: { ids, code },
      });
      window.open(href, "_blank");
    },
    getItems() {
      const len = this.saruIds.length;
      const items = [];
      let lenItem = this.$_.max(this.$_.map(this.itemSelect, (k) => k.length));
      if (lenItem > len) {
        lenItem = len;
      }
      if (lenItem > 0) {
        for (let k in this.itemSelect) {
          const values = this.itemSelect[k];
          let s = values.length;
          if (s > lenItem) {
            s = lenItem;
          }
          for (let inx = 0; inx < s; inx++) {
            if (items.length < inx + 1) {
              items.push([0, 0, 0, 0, 0]);
            }
            items[inx][Number(k) - 1] = Number(values[inx]);
          }
        }
      }
      return items;
    },
    async updateFetchMeta(tokenIds) {
      const items = await this.$store.dispatch(
        "saru/getMetaUpdateByTokenId",
        tokenIds.map(({ tokenId }) => Number(tokenId))
      );
      if (items.length > 0) {
        const data = await this.game.fetchItemMeta(this.tokens.kuniItem, items);
        const saveData = this.$_.keyBy(data.data, ({ tokenId }) =>
          Number(tokenId)
        );
        tokenIds.forEach(({ tokenId, rate }) => {
          tokenId = Number(tokenId);
          if (saveData[tokenId] && rate) {
            saveData[tokenId].rate = rate;
          }
        });
        await this.$store.dispatch("saru/updateMeta", {
          meta: saveData,
        });
        this.mStore.setItemMeta(saveData);
      }
      const data = await this.$store.dispatch(
        "saru/getMetaByTokenId",
        tokenIds.map(({ tokenId }) => Number(tokenId))
      );
      return { data };
    },
    updateItemInit() {
      this.itemSelect = {};
      const self = this;
      if (this.itemIds) {
        this.itemIds.forEach(function (vals) {
          for (let inx = 0; inx < vals.length; inx++) {
            if (vals[inx] > 0) {
              const key = self.utils.toItemTypeBy(vals[inx], true);
              if (!self.itemSelect[key]) self.itemSelect[key] = [];
              self.itemSelect[key].push(vals[inx]);
            }
          }
        });
      }
    },
    async getSuggest(nftAddr, isSaru) {
      const self = this;
      const data = [];
      try {
        const val = this.mSession.getFighting();
        let tmp = [];
        if (val) {
          const [sarus, items] = self.utils.decodeShareLink(val);
          if (isSaru) {
            tmp = sarus.map((t) => self.utils.parseBigInt(t));
          } else {
            items.forEach(function (ls) {
              for (let inx = 0; inx < ls.length; inx++) {
                const t = self.utils.parseBigInt(ls[inx]);
                if (t.gt(0)) {
                  tmp.push(t);
                }
              }
            });
          }
        }
        const foundations = await self.scholar.valuesOf(
          nftAddr,
          "0xD0eE5b7b9eB03eD630BdFcfb9A5b656773139C55"
        );
        for (let index = 0; index < foundations.length; index++) {
          if (!tmp.includes(foundations[index])) {
            tmp.push(foundations[index]);
          }
        }
        if (tmp.length > 0) {
          return await self.scholar.fetchRate(nftAddr, tmp);
        }
      } catch (error) {
        console.log(error);
      }
      return { data };
    },
  },
};
</script>

<style lang="scss">
.box-wrapper {
  .box-info {
    border: 1px solid #8c8c8c;
    .box-title {
      color: #8c8c8c;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      letter-spacing: 0.16px;
    }
    .saru-list {
      display: flex;
      position: relative;
      gap: 16px;
      flex-wrap: wrap;
      justify-content: center;
      .saru-item {
        border-radius: 4px;
        position: relative;
        .img-saru {
          width: 52px;
          height: auto;
          cursor: pointer;
        }
        .note {
          text-align: center;
          background: #cdcdcd;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          font-size: 10px;
          font-weight: 700;
          color: var(--Red, #eb345f);
        }
        .i-close {
          cursor: pointer;
          position: absolute;
          color: var(--Red, #eb345f);
          content: "×";
          top: -3px;
          right: 0px;
          margin: 0;
          padding: 0;
          width: 16px;
          text-align: right;
          height: 16px;
          line-height: 16px;
          font-weight: 800;
        }
      }
    }

    .item-list {
      justify-items: center;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 8px 0;
      flex-wrap: wrap;
      .kuni-item {
        padding: 4px 16px;
        border: 1px solid #eb345f;
        border-radius: 4px;
      }
    }

    .btn-action {
      border: 1px solid #eb345f;
      background-color: transparent;
      &.btn-update {
        border: none;
        background-color: #eb345f;
        &:hover,
        &:focus,
        &:active {
          background-color: #eb345f;
          box-shadow: none !important;
        }
      }
      font-weight: 600;
      border-radius: 8px;
      &:hover,
      &:focus,
      &:active {
        box-shadow: none !important;
      }
    }

    .tb-info {
      display: flex;
      justify-content: space-around;
      .tb-row {
        text-align: center;
        .title {
          &.saru {
            color: #25ffde;
          }
          &.nioh {
            color: #eb345f;
          }
          font-weight: 600;
        }
        .bp {
          font-size: 15px;
          font-weight: 500;
        }
        .score {
          font-size: 13px;
        }
      }
    }
  }
  .box-filter {
    .o-filter {
      display: flex;
      gap: 16px;
      flex-direction: row;
      #sg-1,
      #sg-2 {
        flex: 1;
      }
      .ip-select {
        background: transparent;
        border-color: #434048;
        color: #fff;
        option {
          cursor: pointer;
          background: #20132f;
          &:hover {
            background-color: #482f66;
          }
        }
        optgroup {
          background: #20132f;
        }
      }
      .group-sort {
        display: flex;
        justify-items: flex-end;
        align-items: flex-end;
        gap: 8px;
        .btn-sort {
          margin-bottom: -1px;
          border: 1px solid #434048;
          cursor: pointer;
          background-color: transparent;
          &:active,
          &:focus {
            box-shadow: none;
          }
          &:disabled,
          &.disabled {
            cursor: not-allowed;
          }
        }
      }
    }
    .text-search {
      background: transparent;
      border-color: #434048;
      color: white;
      &::placeholder {
        color: white;
      }
    }
  }
  .box-list {
    #token-list {
      border: none;
      border-bottom: 1px solid #434048;
      color: white;
      .cell-tokenid {
        align-self: center;
        display: flex;
        justify-items: center;
        align-items: center;
        gap: 8px;
        .cell-wrap {
          gap: 8px;
          .thumbnail {
            width: 26px;
            height: auto;
          }
          .custom-checkbox {
            cursor: pointer;
            .custom-control-input:checked ~ .custom-control-label::before {
              background-color: #eb345f;
              border-color: #eb345f;
              cursor: pointer;
            }

            .custom-control-input:focus ~ .custom-control-label::before {
              box-shadow: 0 0 0 1px #eb345f, 0 0 0 0.2rem #eb345f;
              cursor: pointer;
            }
          }
        }

        .ic-power {
          display: flex;
          gap: 4px;
          div {
            padding: 1px 6px;
            border-radius: 4px;
            border: 1px solid #434048;
            img {
              width: 16px;
              height: auto;
            }
          }
        }
      }
    }
  }
  .box-action {
    .w-copied {
      cursor: pointer;
      color: #eb345f;
    }
    .share-link {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
